import React, { useState, useEffect } from 'react';
import { TagCard } from '../cards/tag-card';
import { ShowMore } from '../buttons/show-more.button';

export const TagContainer = ({ items = [], className }) => {
  const [showAll, setShowAll] = useState(false);
  const [maxVisible, setMaxVisible] = useState(15); // default pentru desktop

  useEffect(() => {
    const calculateMaxVisible = () => {
      const width = window.innerWidth;
      const maxRows = 3;

      if (width < 768) { // mobile
        setMaxVisible(Math.floor(maxRows * 2.5)); // ~7 items
      } else if (width < 1024) { // tablet
        setMaxVisible(maxRows * 4); // 12 items
      } else { // desktop
        setMaxVisible(maxRows * 5); // 15 items
      }
    };

    calculateMaxVisible();
    window.addEventListener('resize', calculateMaxVisible);

    return () => window.removeEventListener('resize', calculateMaxVisible);
  }, []);


  if (!Array.isArray(items) || items.length === 0) {
    return null
  }

  const visibleItems = showAll ? items : items.slice(0, maxVisible);
  const needsShowMore = items.length > maxVisible;


  const handleToggle = () => {
    setShowAll(prev => !prev);
  };

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-start gap-2 mb-1">
        {visibleItems.map((item, index) => (
          <div className="h-full flex items-center">
            <TagCard
              key={`${item.name || item.id || 'tag'}-${index}`}
              tag={item}
              className={className}
            />
          </div>
        ))}
      </div>

      {needsShowMore && (
        <div className="flex justify-center">
          <ShowMore
            showMore={showAll}
            onClick={handleToggle}
          />
        </div>
      )}
    </div>
  );
};
